import trustCard from '../../public/static/img/pages/home/2-card-trust.png';
import Image from '../Image';

import SC from './homeElements';

const TrustCardSection = () => {
  return (
    <SC.TrustCardBox>
      <SC.StyledContain className="text-center">
        <SC.Row flexDirection={['column-reverse', 'row']}>
          <SC.Col flexBasis={['0', '40%']} textAlign="left" alignSelf="center">
            <p style={{ fontSize: '1.75rem' }}>
              <strong>ALWAYS MORE</strong> Linkpoints on daily essentials at FairPrice Group.
            </p>
            <p>
              Earn up to 21% savings<sup>*</sup> with Trust when you shop at FairPrice group,
              including FairPrice Supermarket, FairPrice Finest, FairPrice Xtra, FairPrice Online,
              FairPrice Xpress, Kopitiam, Unity and Cheers.
            </p>
            <p>
              <sup>*</sup>T&Cs apply. Visit trustbank.sg for more info.
            </p>
            <SC.StyledButton href={`${process.env.NEXT_PUBLIC_WP_URL}/cards`}>
              Find out more
            </SC.StyledButton>
          </SC.Col>
          <SC.Col flexBasis={['0', '60%']} alignSelf="center">
            <Image
              alt="Trust Card"
              src={trustCard}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw,33vw"
            />
          </SC.Col>
        </SC.Row>
      </SC.StyledContain>
    </SC.TrustCardBox>
  );
};

export default TrustCardSection;
